import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { useBrand } from '~/brand/BrandContext';
import { BRANDS } from '~/brand/brand.config';
import { getBrandTheme } from '~/brand/brand.resolve';
import { IconButton } from '~/components/ui/nucleus/Button/IconButton';

export const handleSupportMessengerOpen = () => {
  const helpUrl =
    typeof window !== 'undefined'
      ? getBrandTheme(window.location.href).helpUrl
      : BRANDS.propfit.helpUrl;
  window.location.href = helpUrl;
};

export const SupportLink = () => {
  const { t } = useTranslation();
  const { helpUrl } = useBrand();

  return (
    <a
      href={helpUrl}
      target='_blank'
      rel='noopener noreferrer'
      className='flex flex-row items-center justify-start gap-3 py-4 text-secondary hover:text-brand lg:gap-0 lg:py-0 lg:text-base'
    >
      <IconButton
        icon={faCircleQuestion}
        size='sm'
        className='hidden text-tertiary lg:block'
        onClick={() => {}}
      />
      <IconButton
        icon={faCircleQuestion}
        size='md'
        className='text-tertiary lg:hidden'
        onClick={() => {}}
      />
      <span className='block lg:hidden'>{t('support')}</span>
    </a>
  );
};
